var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CPOptionDropdown',{attrs:{"value":_vm.transformedValue,"options":_vm.transformedOptions,"label":_vm.label,"placeholder":_vm.placeholder,"disabled":_vm.disabled},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }